export default __webpack_public_path__ + "static/media/pl.541c79ad.svg";